import { QueryClient } from 'react-query'

const client = new QueryClient()

export { client }
